import { render, staticRenderFns } from "./LoginTemplate.vue?vue&type=template&id=4be6d4e9&scoped=true&"
import script from "./LoginTemplate.vue?vue&type=script&lang=js&"
export * from "./LoginTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LoginTemplate.vue?vue&type=style&index=0&id=4be6d4e9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be6d4e9",
  null
  
)

export default component.exports